import { apiRequest } from "./apiClient";

type ContractCategoriesResponse = {
  readonly success: boolean;
  readonly data: string[];
  readonly message: string;
};

export const fetchContractCategories = async (): Promise<string[]> => {
  const response = await apiRequest("/contract-categories");
  const json = (await response.json()) as ContractCategoriesResponse;
  return json.data;
};

export const createContractCategory = async (name: string): Promise<void> => {
  await apiRequest("/contract-categories", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ name }),
  });
};

export const deleteContractCategory = async (name: string): Promise<void> => {
  await apiRequest(`/contract-categories/${encodeURIComponent(name)}`, {
    method: "DELETE",
  });
};
